import { SiteLayout } from '../components/site/SiteLayout';
import { Eyebrow } from '../components/site/PageHero';
import { ServiceLinks } from '../components/site/ServiceLinks';

export default function Services() {
  return (
    <SiteLayout testid="services-page">
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 md:pt-24 pb-24 space-y-12">
        <div className="max-w-3xl space-y-6">
          <div className="rise-in"><Eyebrow>Our Services</Eyebrow></div>
          <h1 className="rise-in font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight" style={{ animationDelay: '80ms' }}>
            Solutions tailored to <span className="text-orange-400">your goals</span>
          </h1>
          <p className="rise-in text-base md:text-lg text-slate-300" style={{ animationDelay: '160ms' }}>Comprehensive retirement, Medicare and insurance guidance. Pick a service to learn more and book a time.</p>
        </div>
        <ServiceLinks />
      </section>
    </SiteLayout>
  );
}
